import React from 'react';
import types from './types';
import percentToHex from '../PercentToHex';
import UIEditorSubcomponent from '../UIEditorSubcomponent';
import Scenario from '../../../classes/scenarioElements/Scenario';
import TextVariables from '../../../classes/TextVariables';

export default function UIOptions(props) 
{
	let properties = {};
	for (let i = 1; i <= props.size; i++) 
	{
		properties['option ' + i.toString() + ' properties'] = {
			type: 'group',
			default: false,
			title: 'Option ' + i.toString(),
		}
		properties['option ' + i.toString() + ' visible'] = {
			type: 'toggle',
			default: true
		}
		properties['option ' + i.toString() + ' text'] = {
			type: 'text',
			default: 'Option ' + i.toString()
		}
		properties['option ' + i.toString() + ' link'] = {
			type: 'step',
		}
		properties['option ' + i.toString() + ' text color'] = {
			type: 'color',
			default: '#ffffff'
		}
		properties['option ' + i.toString() + ' background color'] = {
			type: 'color',
			default: '#4f4f4f'
		}
		properties['option ' + i.toString() + ' shadow color'] = {
			type: 'color',
			default: '#000000'
		}
		properties['option ' + i.toString() + ' text alpha'] = {
			type: 'range',
			default: 100,
			step: 1,
		}
		properties['option ' + i.toString() + ' background alpha'] = {
			type: 'range',
			default: 100,
			step: 1,
		}
		properties['option ' + i.toString() + ' shadow alpha'] = {
			type: 'range',
			default: 100,
			step: 1,
		}
	}

	const extraPorperties = {
		// 'text color': {
		// 	type: 'color',
		// 	default: '#ffffff'
		// },
		// 'background color': {
		// 	type: 'color',
		// 	default: '#4f4f4f'
		// },
		// 'shadow color': {
		// 	type: 'color',
		// 	default: '#000000'
		// },
		// 'text alpha': {
		// 	type: 'range',
		// 	default: 100
		// },
		// 'background alpha': {
		// 	type: 'range',
		// 	default: 100
		// },
		// 'shadow alpha': {
		// 	type: 'range',
		// 	default: 100
		// },
		'layout': {
			type: 'option-layout',
			default: props.layout ? props.layout : 'single column'
		},
		'option spacing': {
			type: 'range',
			default: 200,
			min: 0,
			max: 200,
		},
		'option top padding': {
			type: 'range',
			default: props.top ? props.top : 20,
			max: 70
		},
		'visible': {
			type: 'toggle',
			default: true
		}
	}

	const hiddenProperties = {
		'text color': {
			type: 'color',
			default: '#ffffff'
		},
		'background color': {
			type: 'color',
			default: '#4f4f4f'
		},
		'shadow color': {
			type: 'color',
			default: '#000000'
		},
		'text alpha': {
			type: 'range',
			default: 100
		},
		'background alpha': {
			type: 'range',
			default: 100
		},
		'shadow alpha': {
			type: 'range',
			default: 100
		},
	}

	if (props.getProperties) 
	{
		return { ...properties, ...extraPorperties };
	}

	function calculateTextSize(label, max, min, eMax, eMin, limit1, limit2) 
	{
		return props.context === 'simulation' ? (label.length > limit1 ? label.length > limit2 ? min : max - ((max - min) / 2) : max) : ((label.length > limit1 ? label.length > limit2 ? eMin : eMax - ((eMax - eMin) / 2) : eMax) * props.scale);
	}

	properties = Object.assign({}, properties, extraPorperties);

	if (props.context === 'editor') 
	{
		return (
			<UIEditorSubcomponent
				title={'Options'}
				subcomponent={types.OPTIONS}
				properties={properties}
				{...props}
			/>
		)
	}
	else if (props.data.visible) 
	{
		const simulation = props.context === 'simulation';
		const data = props.data;
		const topPadding = data['option top padding'].value;
		var columnWidth = 30;
		let columnArraySize, left;
		switch (data['layout'].value) 
		{
			case 'single column':
				columnArraySize = 1;
				left = 35;
				break;
			case '2 columns':
				columnArraySize = 2;
				left = 20;
				break;
			case '3 columns':
				columnArraySize = 3;
				left = 5;
				break;
			case '4 columns':
				columnArraySize = 4;
				left = 5;
				columnWidth = 22
				break;
			case '5 columns':
				columnArraySize = 5;
				left = 4;
				columnWidth = 18
				break;
			default:
				break;
		}

		//count amount of options
		let optionCount = 0; //minimum 1 option
		if (data['visible'].value === true)
			while (data['option ' + (optionCount + 1).toString() + ' text']) 
			{
				++optionCount;
			}

		let columns = new Array(columnArraySize);
		let optionIdx = 0;
		let columnIterations = getColumnIterations(optionCount, columns.length);
		for (let i = 0; i < columns.length; i++) 
		{
			let visibleOptionIdx = 0;
			let options = [];
			for (let j = 1; j <= columnIterations[i]; j++) 
			{
				++optionIdx;
				// if (data['option ' + optionIdx.toString() + ' visible'].value)
				{
					++visibleOptionIdx;

					const label = TextVariables.textToData(data['option ' + optionIdx.toString() + ' text'].value);
					const link = data['option ' + optionIdx.toString() + ' link'].value;
					const textAlpha = percentToHex(data['option ' + optionIdx.toString() + ' text alpha'] ? data['option ' + optionIdx.toString() + ' text alpha'].value : data['text alpha'] ? data['text alpha'].value : 100);
					const textColor = (data['option ' + optionIdx.toString() + ' text color']?.value ?? data['text color']?.value ?? '#ffffff') + textAlpha;
					const backgroundAlpha = percentToHex(data['option ' + optionIdx.toString() + ' background alpha'] ? data['option ' + optionIdx.toString() + ' background alpha'].value : data['background alpha'] ? data['background alpha'].value : 100);
					const backgroundColor = (data['option ' + optionIdx.toString() + ' background color']?.value ?? data['background color']?.value ?? '#4f4f4f') + backgroundAlpha;
					const shadowAlpha = percentToHex(data['option ' + optionIdx.toString() + ' shadow alpha'] ? data['option ' + optionIdx.toString() + ' shadow alpha'].value : data['shadow alpha'] ? data['shadow alpha'].value : 100);
					const shadowColor = (data['option ' + optionIdx.toString() + ' shadow color']?.value ?? data['shadow color']?.value ?? '#000000') + shadowAlpha;
					const isVisible = data['option ' + optionIdx.toString() + ' visible'].value;

					options.push(
						<div key={optionIdx}
							className={['ui-preview-option', simulation ? 'simulation' : ''].join(' ')}
							style={{
								backgroundColor: backgroundColor,
								marginTop: visibleOptionIdx > 1 ? (data['option spacing'].value / 20) + '%' : 0,
								borderColor: shadowColor,
								//fontSize: calculateTextSize(label, 28, 14, 24, 14, 14, 18) + "px",//simulation ? 28 : ((label.length > 14 ? label.length > 19 ? 14 : 18 : 24) * props.scale) + "px",
								fontSize: simulation ? "28px" : "0.85vw",
								color: textColor,
								visibility: isVisible ? 'visible' : 'hidden',
							}}
							onClick={(e) => 
							{
								if (link && Scenario.getStep(link)) 
								{
									Scenario.setCurrentStep(Scenario.getStep(link));
								}
							}}
						>
							{label}
						</div>
					);
				}
			}
			columns[i] =
				<center
				  key={i}
				  className='ui-preview-option-column'
				  style={{
				    left: left + (columnWidth * i) + '%',
				    top: topPadding + '%',
				    width: columnWidth + '%',
				  }}
				>
				  {options}
				</center>
		}

		return (
			<div className='ui-preview-options'>
				{columns}
			</div>
		);
	}

	return null;


	function getColumnIterations(totalOptions, totalColumns) 
	{
		let iterations = [];
		let division = Math.floor(totalOptions / totalColumns);
		let remainder = totalOptions % totalColumns;
		if (division === 0) 
		{ // in case we have less items than columns
			for (let i = 0; i < totalColumns; i++) 
			{
				if (remainder > 0) 
				{
					--remainder;
					iterations[i] = 1;
				}
				else 
				{
					iterations[i] = 0;
				}
			}
		}
		else if (remainder === 0) 
		{ // amount of items divides to amount of columns with no remainder
			for (let i = 0; i < totalColumns; i++) 
			{
				iterations[i] = division;
			}
		}
		else 
		{ // we have more items than columns, but there is a remainder
			for (let i = 0; i < totalColumns; i++) 
			{
				iterations[i] = division;
				if (remainder > 0) 
				{
					--remainder;
					++iterations[i];
				}
			}
		}

		return iterations;
	}
}